module.exports = __webpack_public_path__ + "static/slide8-743x573-d48cc8a5ce836998c34acde9975fba9d.gif";